import { createStructuredSelector } from "reselect";
import {
    ROUTE_ADMINISTRATION_GROUP_LIST,
    ROUTE_ADMINISTRATION_GROUP_LIST_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_LIST_ERROR,
    ROUTE_ADMINISTRATION_GROUP_PAGE_SET,
    ROUTE_ADMINISTRATION_GROUP_HEADER,
    ROUTE_ADMINISTRATION_GROUP_SEARCH_SET,
    ROUTE_ADMINISTRATION_GROUP_SEARCH_CHANGE,
    ROUTE_ADMINISTRATION_GROUP_ADD_SET,
    ROUTE_ADMINISTRATION_GROUP_ADD_MODAL_SET,
    ROUTE_ADMINISTRATION_GROUP_ADD,
    ROUTE_ADMINISTRATION_GROUP_ADD_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_ADD_ERROR,
    ROUTE_ADMINISTRATION_GROUP_ADD_CHANGE,
    ROUTE_ADMINISTRATION_GROUP_EDIT_SET,
    ROUTE_ADMINISTRATION_GROUP_EDIT_CHANGE,
    ROUTE_ADMINISTRATION_GROUP_EDIT_MODAL_SET,
    ROUTE_ADMINISTRATION_GROUP_DETAIL,
    ROUTE_ADMINISTRATION_GROUP_DETAIL_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_DETAIL_ERROR,
    ROUTE_ADMINISTRATION_GROUP_UPDATE,
    ROUTE_ADMINISTRATION_GROUP_UPDATE_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_UPDATE_ERROR
} from "../actions";

export const NAME = 'routeAdministrationGroup';

export const RouteAdministrationGroupList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: ROUTE_ADMINISTRATION_GROUP_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const RouteAdministrationGroupListSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_LIST_SUCCESS,
    payload: data
});

export const RouteAdministrationGroupListError = (error) => ({
    type: ROUTE_ADMINISTRATION_GROUP_LIST_ERROR,
    payload: error
});

export const RouteAdministrationGroupPageSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_PAGE_SET,
    payload: data
});

export const RouteAdministrationGroupHeader = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_HEADER,
    payload: data
})

export const RouteAdministrationGroupSearchSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_SEARCH_SET,
    payload: data
});

export const RouteAdministrationGroupSearchChangeSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_SEARCH_CHANGE,
    payload: data
});


export const RouteAdministrationGroupAddChangeSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ADD_CHANGE,
    payload: data
});

export const RouteAdministrationGroupAddSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ADD_SET,
    payload: data
});

export const RouteAdministrationGroupAddModalSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ADD_MODAL_SET,
    payload: data
});

export const RouteAdministrationGroupAdd = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ADD,
    payload: data
});

export const RouteAdministrationGroupAddSuccess = (message) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ADD_SUCCESS,
    payload: message
});

export const RouteAdministrationGroupAddError = (error) => ({
    type: ROUTE_ADMINISTRATION_GROUP_ADD_ERROR,
    payload: error
});

export const RouteAdministrationGroupEditSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_EDIT_SET,
    payload: data
});

export const RouteAdministrationGroupEditChangeSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_EDIT_CHANGE,
    payload: data
});

export const RouteAdministrationGroupEditModalSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_EDIT_MODAL_SET,
    payload: data
});

export const RouteAdministrationGroupEditTabSet = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_EDIT_TAB_SET,
    payload: data
});

export const RouteAdministrationGroupDetail = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_DETAIL,
    payload: data
});

export const RouteAdministrationGroupDetailSuccess = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_DETAIL_SUCCESS,
    payload: data
});

export const RouteAdministrationGroupDetailError = (error) => ({
    type: ROUTE_ADMINISTRATION_GROUP_DETAIL_ERROR,
    payload: error
});

export const RouteAdministrationGroupUpdate = (data) => ({
    type: ROUTE_ADMINISTRATION_GROUP_UPDATE,
    payload: data
});

export const RouteAdministrationGroupUpdateSuccess = (message) => ({
    type: ROUTE_ADMINISTRATION_GROUP_UPDATE_SUCCESS,
    payload: message.message
});

export const RouteAdministrationGroupUpdateError = (error) => ({
    type: ROUTE_ADMINISTRATION_GROUP_UPDATE_ERROR,
    payload: error
});



const routeAdministrationGroup = (state) => state[NAME];

export const RouteAdministrationGroupSelector = createStructuredSelector({
    routeAdministrationGroup
})
